// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__yIlFo","contact":"Footer_contact__J38sW","email":"Footer_email__VwcBy","phone":"Footer_phone__rrZkh"};